module.exports = __webpack_public_path__ + "static/img/3.8698bbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/3.png
// module id = ubBI
// module chunks = 0